module.exports = __webpack_public_path__ + "img/firstNameEle.6f0d9650.svg";